"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = UIDialogFooter;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _UIButtonWrapper = _interopRequireDefault(require("../layout/UIButtonWrapper"));

var ALIGNMENT_OPTIONS = {
  between: 'between',
  left: 'start',
  center: 'center',
  right: 'end'
};

function UIDialogFooter(_ref) {
  var align = _ref.align,
      children = _ref.children,
      className = _ref.className,
      rest = (0, _objectWithoutProperties2.default)(_ref, ["align", "children", "className"]);
  return _react.default.createElement("footer", (0, _extends2.default)({}, rest, {
    className: (0, _classnames.default)('private-modal__footer', 'uiDialogFooter', className)
  }), _react.default.createElement(_UIButtonWrapper.default, {
    justify: ALIGNMENT_OPTIONS[align]
  }, children));
}

UIDialogFooter.propTypes = {
  align: _propTypes.default.oneOf(['left', 'center', 'right', 'between']).isRequired,
  children: _propTypes.default.node
};
UIDialogFooter.defaultProps = {
  align: 'left'
};
UIDialogFooter.displayName = 'UIDialogFooter';
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.3722/js/dialog/UIDialogFooter.js
// module id = 245
// module chunks = 5 6